import ApiService from "@/common/API.service";
import ApiPath from "@/common/config/apiurl.config.json";

export default {
  checkPermission() {
    ApiService.setHeader();
    return ApiService.get(ApiPath.ai.allowed);
  },

  getSuggestion(payload) {
    ApiService.setHeader();
    return ApiService.post(ApiPath.ai.suggestion, payload);
  },

  sendFeedback(payload) {
    ApiService.setHeader();
    return ApiService.post(ApiPath.ai.feedback, payload);
  },
};
